export default "__VITE_ASSET__BsVkyb31__"